import { Typography } from '@mui/material';

export default function TileHeading({ title }) {
    return (
        <Typography color="inherit" variant="h9" sx={{ fontWeight: "bold", padding: 2 }}>
            {title}
        </Typography>
    );

}